export enum SystemMessagePriorityType {
  Neutral = 'neutral',
  Serious = 'serious',
}

